// src/components/form/GroupedQuestionStep.js
/**
 * GroupedQuestionStep
 * -------------------
 * Renders a *set* of questions that belong to the same logical group
 * (e.g. “Medication Details” or “Demographics”). Internally it simply
 * maps over the array and re-uses the existing <QuestionStep/>.
 *
 * Props
 * -----
 * • `questions`  (array)   – Array of question objects (must all share the same `group` key).
 * • `formData`   (object)  – Current form state (answers keyed by question.id).
 * • `onChange`   (fn)      – Input `onChange` handler propagated to each <QuestionStep/>.
 * • `onEnter`    (fn)      – Handler fired when user presses Enter inside any field.
 * • `className`  (string)  – Extra Tailwind / CSS classes for the flex wrapper.
 */

import React, { memo } from "react";
import QuestionStep from "./QuestionStep";

/**
 * Simple rendering; no internal state.
 */
function GroupedQuestionStep({
  questions,
  formData,
  onChange,
  onEnter,
  translationForm,
}) {
  if (!Array.isArray(questions) || !questions.length) return null;

  return (
    <div className={`grouped-question-step flex flex-col gap-2`}>
      {questions.map((q) => (
        <QuestionStep
          key={q.id}
          question={q}
          value={formData[q.id]}
          onChange={onChange}
          onEnter={onEnter}
          translationForm={translationForm}
        />
      ))}
    </div>
  );
}

export default memo(GroupedQuestionStep);
